import fetch from 'utils/fetch';
import qs from 'querystring'

export function loginByEmail(loginName, password) {
    const data = qs.stringify({
        loginName,
        password,
        type: 'uEmail'
    });
    return fetch({
        url: '/av1/admin/login',
        method: 'post',
        data
    });
}

export function logout() {
    return fetch({
        url: '/av1/admin/logout',
        method: 'post'
    });
}

export function getInfo() {
    return fetch({
        url: '/av1/admin/getUserInfo',
        method: 'get'
    });
}




// WEBPACK FOOTER //
// ./src/api/login.js